import React from 'react';
import { FormattedMessage } from 'react-intl';

export type ArticleMode = 'all' | 'production' | 'purchased';

interface Props {
    mode: ArticleMode;
    onChange: (mode: ArticleMode) => void;
    allCount: number;
    productionCount: number;
    purchasedCount: number;
}

const ArticleTabs: React.FC<Props> = ({ mode, onChange, allCount, productionCount, purchasedCount }) => {
    return (
        <div className="art-tabs" role="tablist">
            <button
                type="button"
                role="tab"
                aria-selected={mode === 'all'}
                className={`art-tab ${mode === 'all' ? 'is-active' : ''}`}
                onClick={() => onChange('all')}
            >
                <FormattedMessage id="admin.articles.tab.all" defaultMessage="Të gjitha" />
                <span className="art-tab__count">{allCount}</span>
            </button>
            <button
                type="button"
                role="tab"
                aria-selected={mode === 'production'}
                className={`art-tab ${mode === 'production' ? 'is-active' : ''}`}
                onClick={() => onChange('production')}
            >
                <FormattedMessage id="admin.articles.toggle.forProduction" defaultMessage="Për prodhim" />
                <span className="art-tab__count">{productionCount}</span>
            </button>
            <button
                type="button"
                role="tab"
                aria-selected={mode === 'purchased'}
                className={`art-tab ${mode === 'purchased' ? 'is-active' : ''}`}
                onClick={() => onChange('purchased')}
            >
                <FormattedMessage id="admin.articles.toggle.forWarehouse" defaultMessage="I blerë" />
                <span className="art-tab__count">{purchasedCount}</span>
            </button>
        </div>
    );
};

export default ArticleTabs;
